$(document).ready(function(){
    $('.mobile-toggle').click(function(){
        $('nav .links').toggleClass('active');
    });
});

$(document).on('click', '.dropdown-toggler', function(e){
    e.preventDefault();
    var item = $(this).closest('li');
    if (item.hasClass('m-active')){
        // console.log('HAS');
        item.removeClass('m-active');
        item.removeClass('active');
    } else {
        // console.log('hAS NOT');
        item.addClass('m-active');
        item.addClass('active');
    }
});

$(document).on('mouseenter', 'nav li', function(){
    // console.log('HERE');
    $(this).addClass('active');
});

$(document).on('mouseleave', 'nav li', function(){
    // console.log('HERE 2');
    $(this).removeClass('active');
    $(this).removeClass('m-active');
}); 


$(function () {
    $('#change_vat_type').on('submit', function (e) {
        e.preventDefault();

        const $form = $(this);

        $.ajax({
            url: $form.attr('action'),
            type: 'POST',
            data: $form.serialize(),
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            },
            success: function (response) {
                if (response.message === 'success') {
                    if (response.value === 'inc-vat') {
                        $('html')
                            .removeClass('vat-mode-ex')
                            .addClass('vat-mode-inc');
                    }
                    if (response.value === 'ex-vat') {
                        $('html')
                            .removeClass('vat-mode-inc')
                            .addClass('vat-mode-ex');
                    }
                }
            },
            error: function () {
                console.error('Failed to switch VAT type');
            }
        });
    });

    $('#change_vat_type select[name="vat_type"]').on('change', function () {
        $('#change_vat_type').trigger('submit');
    });
});

// Ajax for Select Item In Google Analytics.
$(document).off('click', '.js-select-item').on('click', '.js-select-item', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    var $link = $(this);
    if ($link.data('tracking-sent')) return;
    $link.data('tracking-sent', true);

    var targetUrl = $link.attr('href');
    var csrfToken = $link.data('csrf'); // Read CSRF directly from attribute

    var payload = {
        product_id: $link.data('product-id'),
        list_name: $link.data('list-name') || 'Product Feed',
        index: parseInt($link.data('index'), 10) || 0
    };

    var navigated = false;
    function navigate() {
        if (!navigated) {
            navigated = true;
            window.location.href = targetUrl;
        }
    }
    setTimeout(navigate, 500);

    $.ajax({
        url: '/shop/analytics/track-select-item/',
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(payload),
        headers: {
            'X-CSRFToken': csrfToken // Pass the extracted token
        }
    }).always(function () {
        navigate();
    });
});

// Custom language dropdown - see templates/partials/language_selector.html
$(function () {
    $(document).on('click', '[data-lang-toggle]', function (e) {
        e.preventDefault();

        const $select = $(this).closest('[data-lang-select]');
        const isOpen = $select.hasClass('open');

        $('[data-lang-select]').not($select).removeClass('open')
            .find('[data-lang-toggle]').attr('aria-expanded', 'false');

        $select.toggleClass('open', !isOpen);
        $(this).attr('aria-expanded', !isOpen);
    });

    $(document).on('click', '.lang_select_option', function (e) {
        e.preventDefault();

        const $select = $(this).closest('[data-lang-select]');

        $select.find('[data-lang-input]').val($(this).data('langCode'));
        $select.closest('form').trigger('submit');
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('[data-lang-select]').length) {
            $('[data-lang-select]').removeClass('open')
                .find('[data-lang-toggle]').attr('aria-expanded', 'false');
        }
    });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape') {
            $('[data-lang-select]').removeClass('open')
                .find('[data-lang-toggle]').attr('aria-expanded', 'false');
        }
    });
});
